module.exports = __webpack_public_path__ + "2f1b71c04ca88bae69f1798880dbc985.js";